/**
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotLoggedInGuard } from "./core/guard/notLoggedIn.guard";
import { LoggedInGuard } from "./core/guard/loggedIn.guard";
/*
const routes: Routes = [
  {
    path: "",
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: "dashboard",
    loadChildren: () => import('./base-layout/base-layout.module').then(m => m.BaseLayoutModule),
  },
  {
    path: 'trip',
    canLoad: [AuthguardGuard],
    component: JourneySharingGoogleMapComponent
  },

  { path: 'contract-using-sim-card', component: UsingSimCardComponent, canActivate: [AuthguardGuard] },
  { path: 'invoice-driver-business', component: InvoiceDriverBusinessComponent, canActivate: [AuthguardGuard] },
  
  { path: 'invoice-society-business', component: InvoiceSocietyBusinessComponent, canActivate: [AuthguardGuard] },

  { path: 'login', component: LoginComponent, canActivate: [NotauthguardGuard] },

  { path: 'forgetpass', component: ForgetpassComponent },

  {
    path: "**",
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
*/

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "auth",
    canActivate: [NotLoggedInGuard],
    loadChildren: () =>
      import("./features/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "dashboard",
    canActivate: [LoggedInGuard],
    loadChildren: () =>
      import("./features/dashboard/dashboard.module").then(
        (m) => m.DashboardModule,
      ),
  },
  /*{
    path: "trip",
    canLoad: [AuthguardGuard],
    component: JourneySharingGoogleMapComponent,
  },

  {
    path: "contract-using-sim-card",
    component: UsingSimCardComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "invoice-driver-business",
    component: InvoiceDriverBusinessComponent,
    canActivate: [AuthguardGuard],
  },

  {
    path: "invoice-society-business",
    component: InvoiceSocietyBusinessComponent,
    canActivate: [AuthguardGuard],
  },

  {
    path: "login",
    component: LoginComponent,
    canActivate: [NotauthguardGuard],
  },*/

  //{ path: "forgetpass", component: ForgetpassComponent },

  {
    path: "**",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
